import { authAxios } from "src/libs/axios/authAxios";

interface GetOneNoticeRes {
  noticeCode: string;
  noticeKo: string;
  noticeEn: string;
  startTime: string;
  endTime: string;
  sendMailYn: string;
  regUserCode: string;
  updUserCode: string;
  entryTime: string;
  updateTime: string;
}
export const getOneNotice = async (): Promise<GetOneNoticeRes[]> => {
  const response = await authAxios.get(`/wapi/cloud/notice/one`);

  return response.data;
};
export const getAllNotice = async (): Promise<any> => {
  const response = await authAxios.get(`/wapi/cloud/notice/all`);

  return response.data;
};
export const newNotice = async (): Promise<any> => {
  const response = await authAxios.get(`/wapi/cloud/notice/new`);

  return response.data;
};
export const updateNotice = async (): Promise<any> => {
  const response = await authAxios.get(`/wapi/cloud/notice/update`);

  return response.data;
};
